// Firebase configuration and services
import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics'; // Commented out as not used yet
import { getFirestore, collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc, query, orderBy, where } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2hU4SrZS12zmld-3s5q2EutLDjRaBJsE",
  authDomain: "dhrti-maa-11.firebaseapp.com",
  projectId: "dhrti-maa-11",
  storageBucket: "dhrti-maa-11.firebasestorage.app",
  messagingSenderId: "297951931087",
  appId: "1:297951931087:web:67fd9e312d0c819c1165ba",
  measurementId: "G-PEG7VJXPWZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // Commented out as not used yet

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Export Firebase functions
export {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  where,
  ref,
  uploadBytes,
  getDownloadURL,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
};

export default app;
